import React from 'react';

import SignUpControl from 'experiments/signup-flow-redesign/control/pages/authentication/sign-up';
import SignUpTreatment from 'experiments/signup-flow-redesign/treatment/pages/authentication/sign-up';
import { useSignupFlowRedesignExperimentGate } from 'experiments/signup-flow-redesign/use-enable-signup-flow-redesign-experiment';

import { ISignup } from './types';

const SignUp = (props: ISignup) => {
  const signupFlowRedesignGate = useSignupFlowRedesignExperimentGate();

  if (!signupFlowRedesignGate.isReady) {
    return null;
  }

  const SignUpComponent = signupFlowRedesignGate.isTreatment ? SignUpTreatment : SignUpControl;

  return <SignUpComponent {...props} />;
};

export default SignUp;
